<template>
    <div>
       <HeaderTeam header="ทีมงานของฉัน" :img_header="header_image" link_back="myteam"/>
       <MenuMyTeamList/>
       <EditTeamList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-team.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuMyTeamList from '@/components/menuadmin/team/myteam/MenuMyTeamList.vue'
import EditTeamList from '@/components/menuadmin/team/myteam/EditTeamList.vue'
export default {
    name:'editTeam',
    components:{
        HeaderTeam,
        MenuMyTeamList,
        EditTeamList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>